import { oz } from '@weft/utils';
import { CreateMeteredEventSchema, CustomerEventSchema } from '../../entities';

export const DbThrottlerEventMessageSchema = oz.object({
  customerEvent: CustomerEventSchema,
  meters: oz.array(CreateMeteredEventSchema),
});
  
export type DbThrottlerEventMessage = oz.infer<typeof DbThrottlerEventMessageSchema>;
